<footer class="mt-auto border-t bg-[#f6f6f6]">
  <div class="mx-auto flex lg:max-w-7xl md:gap-6 px-2 md:px-6 py-2 xs:py-4 lg:py-6 items-center justify-around">
    <div class="flex items-center gap-2 md:gap-3">
      <div class="flex md:h-14 md:w-14 items-center justify-center md:rounded-full md:bg-white">
        <img src="assets/icons/headphones.png" class="mt-1 md:mt-0 h-6 w-6 md:h-8 md:w-8">
      </div>
      <div
        class="md:hidden mt-1 flex items-center gap-2 cursor-pointer"
        (click)="toggleContactInfoMobile()"
      >
        <span>Kundenbetreuung</span>
        <img src="assets/icons/expand-arrow.png" class="h-4 w-4 mt-1" [ngClass]="{ 'rotate-180': showContactInfoMobile }">
      </div>

      <div class="hidden md:block">
        <div class="text-gray-600">Brauchen sie Hilfe? Kontaktieren Sie uns gerne.</div>
        <div class="font-semibold mt-1">{{ brand.name }} Kundenbetreuung - Einwilligungsverwaltung</div>
        <div class="text-gray-800 mt-4 flex items-center gap-10">
          <div class="flex items-center gap-2">
            <img src="assets/icons/phone-outline.png" class="h-5 w-5">
            <a [href]="'tel:' + legalEntity.phone" class="hover:underline">
              {{legalEntity.phone}}
            </a>
          </div>
          <div class="flex items-center gap-2">
            <img src="assets/icons/mail2.png" alt="" class="h-5 w-5">
            <a [href]="'mailto:' + legalEntity.email" class="hover:underline">
              {{legalEntity.email}}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="border-l-[1.5px] h-[50px]"></div>

    <div class="flex justify-center items-center">
      <a [href]="legalEntity.impressumUrl" target="_blank" class="underline">
        Impressum
      </a>
    </div>
  </div>

  @if (showContactInfoMobile) {
    <div class="px-2 md:px-6 md:hidden">
      <div class="w-full py-4 border-t-[1.5px]">
        <div class="text-gray-600">Brauchen sie Hilfe? Kontaktieren Sie uns gerne.</div>
        <div class="font-semibold mt-1">{{ brand.name }} Kundenbetreuung - Einwilligungsverwaltung</div>
        <div class="text-gray-800 mt-4 flex flex-wrap items-center gap-6">
          <div class="flex items-center gap-2 min-w-[170px]">
            <img src="assets/icons/phone-outline.png" alt="" class="h-5 w-5">
            <a [href]="'tel:' + legalEntity.phone" class="hover:underline">
              {{legalEntity.phone}}
            </a>
          </div>
          <div class="flex items-center gap-2 min-w-[190px]">
            <img src="assets/icons/mail2.png" alt="" class="h-5 w-5">
            <a [href]="'mailto:' + legalEntity.email" class="hover:underline">
              {{legalEntity.email}}
            </a>
          </div>
        </div>
      </div>
    </div>
  }
</footer>
